<template>
  <div class="container ingreso-manual">
    <div class="header">
      <div id="navigation-back" @click.prevent="back">
        <figure id="back-figure">
          <img src="../../static/img/back.png" alt="Volver">
        </figure>
      </div>
      <div id="navigation-home" @click.prevent="goInicio">
        <figure id="home-figure">
            <img src="../../static/img/home.png" alt="Inicio">
        </figure>
      </div>
    </div>
    <div class="section">
      <div class="logo">
        <figure>
          <img src="../assets/logo.png" alt="DIRECTV">
        </figure>
      </div>
      <div class="form">
        <b-form>
          <b-form-group>
            <b-form-input 
              id="username"
              v-model.trim="username" 
              placeholder="Usuario"
              type="text">
            </b-form-input>
          </b-form-group>
          <b-form-group>
            <b-form-input 
              id="password"
              v-model.trim="password" 
              placeholder="Password"
              type="password">
            </b-form-input>
          </b-form-group>
          <b-button :class="{ link: true, 'button-loading': loading }"
            @click.prevent="login">INGRESAR</b-button>
        </b-form>
      </div>
    </div>
    <!--
    <b-alert
      v-model="error"
      dismissible
      fade
      variant= "warning">
      <p>{{ errorMessage }}</p>
    </b-alert>    
    -->
    <b-alert
      v-model="error"
      variant= "warning">
      <p>{{ errorMessage }}</p>
    </b-alert>    
    <div v-show="loading" class="spinner">
      <b-spinner small />
    </div>    
  </div>
</template>

<script>
export default {
  data () {
    return {
      username: '',
      password: '',
      loading: false,
      error: false,
      errorMessage: '',
    }
  },
  created () {
  },
  methods: {
    login () {
      this.error = false;
      this.errorMessage = '';
      
      if (this.loading) {
        return;
      }

      if (this.username.trim() == '') {
        return;
      }
      if (this.password.trim() == '') {
        return;
      }

      var credenciales = {
        username: this.username,
        password: this.password,
      };
      
      this.loading = true;

      this.$store.dispatch('user/login', credenciales)
        .then(response => {
          if (this.$store.getters['user/loggedIn']) {
            this.$router.push({ name: 'SeleccionEvento' });
          } else {
            this.$router.push({ name: 'Inicio' });
          }
          this.loading = false;
        })
        .catch( error => {
          this.error = true;
          this.errorMessage = error;
          this.loading = false;
        });
    },
    back () {
      this.$router.go(-1)
    },
    goInicio () {
      this.$router.push({ name: 'Inicio' });
    }
  },
}
</script>

<style scoped>
  div.spinner {
    position: relative;
    top: -60px;
  }
  div.spinner span{
    position: relative;
    left: 20px;
  }
  .button-loading {
    opacity: 0.2;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue